import Vue from 'vue'
import axios from "axios";
import { Message,Notification } from "element-ui";
import store from "../store";
import { getCookie, Token } from "@/utils/cookie";
import router from "../router/index";

// 后端联调接口  打包V-1.0
// const url = 'http://127.0.0.1:8089' //彭
// const url = 'http://wisdomorg.oicp.net:8180'
// const url = 'http://192.168.1.121:8180'
// const url = 'http://172.30.6.161:8180' //寸滩外集卡算法测试
//  const url = 'http://222.178.71.137:8189' //寸滩外集卡外网
//  const url = 'http://172.0.10.86:8189' //外集卡果园内网
const url = 'http://www.cqppl.com:8189' //<<<<<<<<<< 果园外网 正式  <<<<<<<<<<
//const url = 'https://cqppl.com'
//const url = 'http://cqppl.com'
//const url = 'http://192.168.1.121:9080' //测试地址1   <<<<<<<<<< 果园 二期 测试地址
//const url = 'http://172.0.10.161:8080' // 果园测试地址2
// const url = 'http://wisdomorg.oicp.net:9080' //果园 无纸化 测试地址2  <<<<<<<<<<
//const url = 'http://192.168.200.12:8089' //渝巴内网
//const url = 'http://106.91.213.226:8089' //渝巴 正式 地址 <<<<<<<<<
//const url = 'http://192.168.1.74:8280' //渝巴 左小兵 <<<<<<<<<
//  const url = 'http://47.107.228.233:8090' //公司云服务器

//const url="http://106.91.213.226:18089";//<<<<<<<<<< 渝巴 测试地址  <<<<<<<<<
//const url="http://192.168.1.68:8089";//<<<<<<<<<< 相交  <<<<<<<<<

//const url="http://172.0.10.161:8080";  //161 演示地址
//const url="http://192.168.1.72:8089"; //官涛
//const url="http://192.168.1.54:8089";// 相交
//const url="http://172.0.10.161:8080"  //林晓龙
//const url ='http://192.168.1.88:8089' //雷刘

//swager API 接口文档地址  http://106.91.213.226:18089/doc.html

//const url="https://127.0.0.1:443";  //艾开忠
//const url="http://127.0.0.1:9090";  //艾开忠
//const url="http://192.168.1.182:8089"; //飞哥


// const url = process.env.NODE_ENV === 'development' ? '/api' : 'http://wisdomorg.oicp.net:8180'
// const url_admin = '../../../..'  //本地
//const isShowDdyb = 'yb' // 到货预报模块是否显示  '渝巴 显示 yb'
const isShowDdyb = 'gy,ct' // 到货预报模块是否显示  '果园显示 gy,ct','渝巴 显示 yb'
const url_admin = '../../../../qd' //外网正式环境/121环境
//const url_admin = '' //测试环境 地图打包


Vue.prototype.$index = process.env.NODE_ENV==='development'?url:'../'
Vue.prototype.$admin = url_admin
Vue.prototype.$isShowDdyb = isShowDdyb
// 创建axios实例

if(isShowDdyb == 'yb'){
    Vue.prototype.$shouHuoRen = "需求标识"
    Vue.prototype.$chuanGongSi = "车公司"

    Vue.prototype.$gangToZhan = "站"
    Vue.prototype.$chuanToChe = "车"
    Vue.prototype.$chuanToHuo = "货"
    Vue.prototype.$hangToLie = "列"

    Vue.prototype.$chuanMing = "车皮号"
    Vue.prototype.$hangCi = "班列号"
    Vue.prototype.$chuanDai= "货代"

    Vue.prototype.$chuGang= "出站"
    Vue.prototype.$jinGang= "进站"

}else{
    Vue.prototype.$shouHuoRen = "收货人"
    Vue.prototype.$chuanGongSi = "船公司"

    Vue.prototype.$gangToZhan = "港"
    Vue.prototype.$chuanToChe = "船"
    Vue.prototype.$chuanToHuo = "船"
    Vue.prototype.$hangToLie = "航"

    Vue.prototype.$chuanMing = "船名"
    Vue.prototype.$hangCi = "航次"
    Vue.prototype.$chuanDai= "船代"

    Vue.prototype.$chuGang= "出港"
    Vue.prototype.$jinGang= "进港"
}

Vue.prototype.$serverUrl = url

const service = axios.create({
    baseURL: process.env.NODE_ENV==='development'?url:'../', // 开发环境跨域配置的地址
    timeout: 300000000 // 请求超时时间
});

const loadingOver = () => {
    if (store.getters.loadingBtn) {
        store.commit("SET_LOADING_STATUS", false);
    }
};



// request拦截器
service.interceptors.request.use(
    config => {
        // 请求头统一配置
        config.headers["Content-Type"] = "application/json";
        //config.headers["Accept"] = "application/json;charset=UTF-8";
        if (getCookie(Token)) {
            //config.headers["Access-Control-Allow-Origin"] = "http://localhost:9999";
            //config.headers["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";
            config.headers["Authorization"] = getCookie(Token); // 请求头携带Authorization为Token值
        }

        // if (config.method === "get" || config.method === "put" || config.method === "post") {
            store.commit("SET_LOADING_STATUS", true);
        // }
        return config;
    },
    error => {
        loadingOver();
        Promise.reject(error);
    }
);

// response拦截器
service.interceptors.response.use(
    response => {
        loadingOver();
        return response.data;
    },
    error => {
        loadingOver();
        //console.log("拦截器 error",error.response)
        console.log("拦截器 error",error)
        // let message = error.response.data.msg
        let message =
            error.response.data.msg || error.response.data.error || false;
        let msg = "";
        if (message) {
            if(message.indexOf("没有找到指定的登录用户") > -1){
                console.log("没有找到指定的登录用户")
                router.replace("/Login");
                return;
            }else{
                msg =
                    message.indexOf("错误信息:") > 0
                        ? message.split("错误信息:")[1]
                        : message;
                Message({
                    message: `${msg}`,
                    showClose: true,
                    type: "error",
                    duration: 0
                });
                // Notification({
                //     title: '提示',
                //     message: `${msg}`,
                //     duration: 0,
                //     showClose: true,
                //     type: "error"
                // });
            }
        } else {
            msg = "服务器异常,请联系系统管理员";
            // Notification({
            //     title: '提示',
            //     message: `${msg}`,
            //     duration: 0,
            //     showClose: true,
            //     type: "error"
            // });
            Message({
                message: `${msg}`,
                showClose: true,
                type: "error",
                duration: 0
            });
        }
        if (error.response.status === 504 || error.response.status === 511||msg.indexOf('用户未登录')>0) {
            console.log("error.response.status 504 511 用户未登录")
            router.replace("/Login");
            return;
        }

        return Promise.reject(error);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/index.js